import { render, staticRenderFns } from "./baseInfoModules.vue?vue&type=template&id=6b9a8552&scoped=true&"
import script from "./baseInfoModules.vue?vue&type=script&lang=js&"
export * from "./baseInfoModules.vue?vue&type=script&lang=js&"
import style0 from "./baseInfoModules.vue?vue&type=style&index=0&id=6b9a8552&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9a8552",
  null
  
)

export default component.exports